// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/screens/UserCategories/index.css
// module id = 2373
// module chunks = 0